<template>
  <router-view></router-view>
</template>

<script>
export default {
  metaInfo: {
    title: 'Android Game Account Deletion',
  },
};
</script>
